import { getInjection } from '@/di/inversify.config';
import { Result } from '@/entities/Result';
import { TeamLeagueTeamsInfo } from '@/entities/TeamLeagueTeamsInfo';
import { SearchParams } from '@/infrastructure/network/data/team-leagues-players';

export const listTeamLeaguesTeamsUseCase = async (
	organizationUuid: string,
	teamLeagueUuid: string,
	searchParams?: SearchParams
): Promise<Result<TeamLeagueTeamsInfo[]>> => {
	const teamLeagueTeamsRepository = getInjection('ITeamLeagueTeamsRepository');
	return teamLeagueTeamsRepository.listTeamLeaguesTeams(organizationUuid, teamLeagueUuid, searchParams);
};
